<template>
  <div class="decoration-page">
    <div class="designer-cnt" @click.self="cancelSelect">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="常用组件" name="1">基本组件待加入</el-tab-pane>
        <el-tab-pane label="基础组件" name="2">
          
        </el-tab-pane>
      </el-tabs> -->
      <!-- 左侧 -->
      <div class="comp-group">
        <div class="decorate-class" v-if="false">
          <div class="d-c-header">装修分类</div>
          <div class="decorate-class-list" v-for="(item, index) in decorateClassList" :key="index"
            v-loading="DCSelectlosding" @click="handleDCSelect(item, index)"
            :class="decorateClassIndex == index ? 'cur_dc' : ''">
            {{ item.className }}
          </div>
        </div>
        <div style="width: 100%;flex-grow: 1;padding-left: 10px;">
          <!-- <div style="width: 100%;text-align: center;">
            <el-radio-group v-model="radio" @change="radioChange" style="margin: 0 auto;">
              <el-radio-button label="1">常用组件</el-radio-button>
              <el-radio-button label="2">基础组件</el-radio-button>
            </el-radio-group>
          </div> -->
          <el-collapse v-model="activeCollapse" @change="handleCollapseChange">
            <el-collapse-item title="页面装修" name="1">
              <div class="" ref="complist1">
                <!-- filter=".forbid" -->
                <draggable tag="div" class="cardDrag-list-wrap comp-list" v-model="compList" :group="groupLeft"
                  :sort="false" animation="100" @start="handleLStart">
                  <div class="comp-item"
                    :class="curDecorateClass.renovationCode == 'dailyDiscountModel' && ['goods_weapp', 'shop_banner_weapp', 'enter_store', 'shelf_asset', 'r_audio'].includes(item.assemblyCode) ? 'forbid' : ''"
                    v-for="(item, index) in compList" :key="index" @click="handleLClick(item, index)">
                    <div class="assembly_img">
                      <el-image style="width: 100%;" :src="item.assemblyUrl" fit="cover"></el-image>
                    </div>
                    <!-- <el-image style="width: 40px; height: 40px;transform: translateY(12px);" :src="item.assemblyUrl" fit="contain"></el-image> -->
                    <div>{{ item.assemblyName }}</div>
                  </div>
                </draggable>
              </div>
            </el-collapse-item>
            <el-collapse-item title="商品" name="2">
              <div class="" ref="compList1s1">
                <!-- filter=".forbid" -->
                <draggable tag="div" class="cardDrag-list-wrap comp-list" v-model="compList1s1" :group="groupLeft"
                  :sort="false" animation="100" @start="handleLStart">
                  <div class="comp-item" v-for="(item, index) in compList1s1" :key="index"
                    :class="curDecorateClass.renovationCode == 'dailyDiscountModel' && ['goods_weapp'].includes(item.assemblyCode) ? 'forbid' : ''"
                    @click="handleLClick(item, index)">
                    <div class="assembly_img">
                      <el-image style="width: 100%;" :src="item.assemblyUrl" fit="cover"></el-image>
                    </div>
                    <div>{{ item.assemblyName }}</div>
                  </div>
                </draggable>
              </div>
            </el-collapse-item>
            <el-collapse-item title="营销活动" name="3">
              <div class="" ref="compList1s2">
                <draggable tag="div" class="cardDrag-list-wrap comp-list" v-model="compList1s2" :group="groupLeft"
                  :sort="false" animation="100" @start="handleLStart">
                  <div class="comp-item" v-for="(item, index) in compList1s2" :key="index"
                    @click="handleLClick(item, index)">
                    <div class="assembly_img">
                      <el-image style="width: 100%;" :src="item.assemblyUrl" fit="cover"></el-image>
                    </div>
                    <div>{{ item.assemblyName }}</div>
                  </div>
                </draggable>
              </div>
            </el-collapse-item>
          </el-collapse>
          <!-- <el-button type="warning" @click="handleAssemblySave">Save</el-button> -->
        </div>
      </div>
      <!-- 左侧 -->
      <!-- 中间 -->
      <div ref="displaybody" class="display-body">
        <div class="cardDrag-container common-container">
          <draggable tag="div" class="cardDrag-list-wrap" v-model="compList2" :group="groupCenter" animation="100"
            delay="10" :sort="true" @start="handleCStart" @add="handleAdd">
            <div class="comp-item" v-for="(item, index) in compList2" :key="item.sortId"
              @click="handleCClick(item, index)">
              <div class="comp_operate" v-if="selected && index == attrItemDataIndex">
                <i class="el-icon-delete" @click="handleCompDelete(item, index)"></i>
              </div>
              <div class="item_cnt">
                <div :ref="item.sortId" :id="item.sortId">
                </div>
              </div>
              <div :class="selected && index == attrItemDataIndex ? 'active_comp' : ''"></div>
            </div>
          </draggable>
        </div>
        <div id="targetEl" ref="targetEl" class="targetEl">
          <el-button type="success" @click="handleRenovationDetailSave">保存</el-button>
        </div>
      </div>
      <!-- 中间 -->
      <!-- 右侧 -->
      <div class="attr-layer">
        <div class="attr-page-manage">
          <div class="a-l-header">页面布局</div>
          <div class="attr-list">
            <draggable tag="div" class="cardDrag-list-wrap comp-list" v-model="compList2" :group="groupRight"
              animation="100" delay="10" :sort="true" @start="handleRStart" @add="handleAdd">
              <div class="attr-list-item comp-item" :class="attrItemDataIndex == index ? 'active_comp' : ''"
                v-for="(item, index) in compList2" :key="item.sortId" @click="handleRClick(item, index)">
                <i class="el-icon-s-operation alii"></i>
                {{ item.assemblyName }}
              </div>
            </draggable>
          </div>
        </div>
        <div class="attr-detail"
          :style="compList2[attrItemDataIndex] && compList2[attrItemDataIndex].assemblyCode == 'rich_text_weapp' ? [{ 'overflow': 'visible' }] : ''">
          <div class="" v-if="compList2[attrItemDataIndex]">
            <titleTextAttr v-if="compList2[attrItemDataIndex].assemblyCode == 'titleText'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <imageAdAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'new_image_ad'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <whiteLineAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'white_line'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <goodsWeappAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'goods_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <couponWeappAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'coupon_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <grouponWeappAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'groupon_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <secKillAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'ump_seckill'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <bargainAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'bargain'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <rsearchAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'r_search'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <shopBannerAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'shop_banner_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <noticeWeappAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'notice_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <imgtextnavAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'image_text_nav'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" @updateRd="handleRenovationDetailSaveAuto" />
            <enterstoreAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'enter_store'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <shelfassetAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'shelf_asset'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <raudioAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'r_audio'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <richtextweappAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'rich_text_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <activityWeappAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'activity_weapp'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
            <marketZoneAttr v-else-if="compList2[attrItemDataIndex].assemblyCode == 'market_zone'"
              v-model="compList2[attrItemDataIndex].assemblyAttr" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import draggable from 'vuedraggable'
// 模板样式
import {
  titleText, imageAd, whiteLine, goodsWeapp, couponWeapp, grouponWeapp, secKill, bargain,
  rsearch, shopBanner, noticeWeapp, imgtextnav, enterstore, shelfasset, raudio, richtextweapp, activityWeapp, marketZone
} from './components/index'
// 模板配置
import {
  titleTextAttr, imageAdAttr, whiteLineAttr, goodsWeappAttr, couponWeappAttr, grouponWeappAttr, secKillAttr, bargainAttr,
  rsearchAttr, shopBannerAttr, noticeWeappAttr, imgtextnavAttr, enterstoreAttr, shelfassetAttr, raudioAttr, richtextweappAttr, activityWeappAttr,
  marketZoneAttr
} from './components/index'
export default {
  components: {
    draggable,
    titleTextAttr,
    imageAdAttr,
    whiteLineAttr,
    goodsWeappAttr,
    couponWeappAttr,
    grouponWeappAttr,
    secKillAttr,
    bargainAttr,
    rsearchAttr,
    shopBannerAttr,
    noticeWeappAttr,
    imgtextnavAttr,
    enterstoreAttr,
    shelfassetAttr,
    raudioAttr,
    richtextweappAttr,
    activityWeappAttr,
    marketZoneAttr
  },
  data() {
    return {
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        currPage: 1,
        condition: {}
      },
      form: {},
      selected: true,
      DCSelectlosding: false,
      decorateClassIndex: 0,//当前分类序号
      curDecorateClass: {},//当前分类
      decorateClassList: [],//装修分类
      decorateAssemblyList: [],//装修组件
      height: window.innerHeight - 256, //表格高度
      headerHeight: 0,
      radio: '1',
      activeCollapse: ['1', '2', '3'],
      compList: [//页面装修
      ],
      compList1s1: [],//商品
      compList1s2: [],//营销组件
      compList2: [
      ],
      groupLeft: {
        name: 'itxst',
        pull: 'clone',  // 拖出 true, false, 'clone', array , function
        put: false,   // 拖入
      },
      groupCenter: {
        name: 'itxst',
        pull: false,  // 拖出
        put: true,   // 拖入
      },
      groupRight: {
        name: 'itxst2',
        pull: false,  // 拖出
        put: false,   // 拖入
      },
      computedStyle: {},
      attrItemDataIndex: 0,
      assemblyAttr: [],
    };
  },

  created() {
    this.getClassList()
    this.getAssemblyList()
  },

  mounted() {
    // this.$nextTick(() => {
    //   // 获取定义ref属性 和 元素高度
    //   // this.headerHeight = this.$refs.search_d.offsetHeight;
    //   window.addEventListener('resize', this.getHeight())
    // })
  },

  methods: {
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - this.headerHeight - 256;
    },
    initdraggable() {
    },
    // 添加
    handleAdd(e) {
      console.log('ad=d', e)
      const newIndex = e.newIndex
      // 深拷贝
      const newComp = _.cloneDeep(this.compList2[newIndex])
      newComp.sortId = 'comp' + this.randomNumber()
      delete newComp.id
      this.compList2.splice(newIndex, 1, newComp)
      console.log('ad=d----z', this.compList2, newIndex)
      this.$nextTick(() => {
        setTimeout(() => {
          this.addNode(newComp.sortId, newIndex, newComp.assemblyCode)
        }, 0)
      })
    },
    // 删除
    handleCompDelete(item, index) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(confirm => {
        this.compList2.splice(index, 1)
      }).catch(err => { })
    },
    // 选中组件
    handleChoose(e) {
      console.log(e)
    },
    // 点击 左侧 组件
    handleLClick(e, index) {
      console.log('clic--t-LLLL', e)
      if (this.curDecorateClass.renovationCode == 'dailyDiscountModel' && ['goods_weapp', 'shop_banner_weapp', 'enter_store', 'shelf_asset', 'r_audio'].includes(e.assemblyCode)) {
        this.$message.info('因容量大小限制，暂不支持该组件加入首页！')
      }
    },
    // 点击 中间 组件
    handleCClick(e, index) {
      this.attrItemDataIndex = index
      this.selected = true
    },
    // 点击 右侧 组件
    handleRClick(e, index) {
      this.attrItemDataIndex = index
      this.selected = true
    },
    // 移动 左侧 开始
    handleLStart(e) {
      console.log('star--t-LLL', e)
    },
    // 移动 中间 开始
    handleCStart(e) {
      this.attrItemDataIndex = e.oldIndex
    },
    // 移动 右侧 开始
    handleRStart(e) {
      this.attrItemDataIndex = e.oldIndex
    },
    // 取消选中
    cancelSelect() {
      this.selected = false
    },
    // 移动终止
    handleEnd(e) {
      console.log('en--d', e)
    },
    handleDataChange(item) {
      console.log('Dat---aChange', item, this.compList2)
    },
    // 获取随机数
    randomNumber() {
      const rm = Math.floor(Math.random() * 10e7)
      return rm
    },

    // 创建节点----------------------------------------------------------
    addNode(sortId, newIndex, assemblyCode) {
      const divEl = document.createElement('div');
      divEl.id = 'ext' + sortId;
      // console.log('tar--getEl',this.$refs[sortId],divEl)
      this.$refs[sortId][0] && this.$refs[sortId][0].appendChild(divEl);
      this.extendComponent(divEl.id, newIndex, assemblyCode)
    },
    // 挂载组件
    extendComponent(extid, newIndex, assemblyCode) {
      // 使用基础 Vue 构造器，创建一个“子类”
      let assemble = null
      //判断组件类型
      switch (assemblyCode) {
        case "titleText":
          assemble = titleText
          break;
        case "new_image_ad":
          assemble = imageAd
          break;
        case "white_line":
          assemble = whiteLine
          break;
        case "goods_weapp":
          assemble = goodsWeapp
          break;
        case "coupon_weapp":
          assemble = couponWeapp
          break;
        case "groupon_weapp":
          assemble = grouponWeapp
          break;
        case "ump_seckill":
          assemble = secKill
          break;
        case "bargain":
          assemble = bargain
          break;
        case "r_search":
          assemble = rsearch
          break;
        case "shop_banner_weapp":
          assemble = shopBanner
          break;
        case "notice_weapp":
          assemble = noticeWeapp
          break;
        case "image_text_nav":
          assemble = imgtextnav
          break;
        case "enter_store":
          assemble = enterstore
          break;
        case "shelf_asset":
          assemble = shelfasset
          break;
        case "r_audio":
          assemble = raudio
          break;
        case "rich_text_weapp":
          assemble = richtextweapp
          break;
        case "activity_weapp":
          assemble = activityWeapp
          break;
        case "market_zone":
          assemble = marketZone
          break;
        default:
          break;
      }
      const AComponentsEx = Vue.extend(assemble);
      // 创建实例，并挂载到指定 id 上
      const aComponents = new AComponentsEx().$mount('#' + extid);
      // 可传入 props 值
      aComponents.$props.compData = this.compList2[newIndex].assemblyAttr
      this.attrItemDataIndex = newIndex
    },
    // 销毁组件
    destoryComponent() {
      // 注意此时没有 id 为 test 的节点，已被 id test2 替换
      const testEl = document.getElementById('test');
      document.body.removeChild(testEl);
    },
    // 挂载节点----------------------------------------------------------

    // handleClick(tab, event) {
    //   console.log(tab, event);
    // },
    radioChange(val) {
      // this.activeCollapse = [val]
    },
    handleCollapseChange(val) {
      console.log(val);
    },

    // 点击分类
    handleDCSelect(item, index) {
      if (this.DCSelectlosding) {
        return
      }
      this.DCSelectlosding = true
      setTimeout(() => {
        this.DCSelectlosding = false
      }, 500)
      this.curDecorateClass = JSON.parse(JSON.stringify(item))
      this.decorateClassIndex = index
      this.getCurDecorateClass()
    },
    //获取 装修分类
    getClassList() {
      var that = this;
      const _data = {
        isUse: 1,//是否上架 1 是 2 否
      }
      that.$http.post("/renovationClass/queryList", _data).then(function (response) {
        if (response.data.code == 200) {
          that.decorateClassList = response.data.data;
          that.curDecorateClass = response.data.data?.[0] || {}
          that.decorateClassIndex = 0
          that.getCurDecorateClass()
        }
      });
    },
    //获取 装修组件
    getAssemblyList() {
      var that = this;
      const _data = {
        // assemblyType: 1,//组件类型 1：基本组件 2：营销组件
      }
      that.$http.post("/renovationAssembly/queryList", _data).then(function (response) {
        if (response.data.code == 200) {
          that.decorateAssemblyList = response.data.data;
          // rich_text_weapp
          const _decorateAssemblyList = response.data.data.filter(item => !['r_audio'].includes(item.assemblyCode)).map(item => {
            let _assemblyAttr = []
            try {
              _assemblyAttr = JSON.parse(item.assemblyAttr)
            } catch (error) {

            }
            return {
              ...item,
              assemblyAttr: _assemblyAttr
            }
          })
          that.compList = _decorateAssemblyList.filter(item => item.assemblyType == 1)
          that.compList1s1 = _decorateAssemblyList.filter(item => item.assemblyType == 2)
          that.compList1s2 = _decorateAssemblyList.filter(item => item.assemblyType == 3)
        }
      });
    },

    //获取 装修分类详情
    getCurDecorateClass() {
      var that = this;
      const _data = {
        renovationCode: this.curDecorateClass.renovationCode,//装修编码
        merchantCode: localStorage.getItem("merchantCode")
      }
      that.compList2 = []
      that.$http.post("/renovationDetail/queryList", _data).then(function (response) {
        if (response.data.code == 200) {
          that.compList2 = response.data.data.map(item => {
            return {
              ...item,
              assemblyAttr: JSON.parse(item.assemblyAttr),
              sortId: item.id + ''
            }
          })
          that.$nextTick(() => {
            console.log('add-0', that.compList2)
            setTimeout(() => {
              that.compList2.forEach((item, i) => {
                that.addNode(item.sortId, i, item.assemblyCode)
              })
            }, 0)
          })
        }
      });
    },

    // 保存 组件默认配置
    handleAssemblySave() {
      var that = this;
      console.log('??--0', that.decorateAssemblyList)
      this.$confirm(`确定更新 ${that.decorateAssemblyList[16].assemblyName} 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(confirm => {
        const _data = {
          id: that.decorateAssemblyList[16].id,
          assemblyAttr: JSON.stringify(
            {
              attr: {
                a0: {
                  label: '添加活动', value: [], key: 'goodsList', type: 'data', tag: '', sid: 'goods_weapp_s0',
                  groupList: [{
                    activityName: '',
                    activityCode: '',
                    activityTitle: '',
                    categoryList: [],
                  }],
                },
                a1s: {
                  label: '展示模式', value: '1', key: 'modetype', type: 'data', tag: '', sid: 'goods_weapp_s2',
                  showList: {
                    '1': '模式一',
                    '2': '模式二',
                  },
                },
                a1: {
                  label: '列表样式', value: 1, key: 'listStyle', type: 'data', tag: '', sid: 'goods_weapp_s1',
                  options: [
                    { name: '一行一个', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
                    { name: '一行两个', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' },
                    { name: '一行三个', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
                    { name: '大图模式', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' },
                    { name: '横向滑动', img1: 'https://img01.yzcdn.cn/upload_files/2022/08/23/FhW2ZJpDPxh0Q-ZTtfOJ7itWtZF_.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/08/23/Ft1GxcBJBmtbjahNVZOPWBrbIj3d.png' },
                    { name: '一大两小', img1: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FluleLjR6gMJ9p_H9P5WEAhgPa8d.png', img2: 'https://img01.yzcdn.cn/upload_files/2022/09/15/FkdiKOW0JN9yIoDhGRXaeJQ6H8TJ.png' },
                  ],
                },

                a1t: {
                  label: '活动标题', value: '1', sid: 'goods_weapp_s5',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsInfo', type: 'style', tag: 'radio'
                },
                a2p: {
                  label: '背景颜色', value: '#fff4f3', sid: 'attr_s',
                  showList: {}, default: '#fff4f3',
                  key: 'background', type: 'style', tag: 'ColorPicker'
                },
                a2: {
                  label: '商品样式', value: '4', key: 'goodsStyle', type: 'data', tag: '', sid: 'goods_weapp_s2',
                  showList: {
                    '1': '无边白底',
                    '2': '卡片投影',
                    '3': '描边白底',
                    '4': '无边透明底',
                  },
                },
                a3b: {
                  label: '整体倒角', value: '16px', sid: 'g',
                  showList: {
                    'unset': '直角',
                    '16px': '圆角'
                  },
                  key: 'border-radius', type: 'style', tag: 'radio'
                },
                a3: {
                  label: '商品倒角', value: 'unset', sid: 'goods_weapp_s6',
                  showList: {
                    'unset': '直角',
                    '8px': '圆角'
                  },
                  key: 'border-radius', type: 'style', tag: 'radio'
                },
                a4: {
                  label: '图片比例', value: '66.67%', sid: 'goods_weapp_s7',
                  showList: {
                    '66.67%': '3:2',
                    '100%': '1:1',
                    '133.33%': '3:4',
                    '56.25%': '16:9'
                  },
                  key: 'padding-top', type: 'style', tag: 'radio'
                },
                a5: {
                  label: '图片填充', value: 'cover', sid: 'goods_weapp_s8',
                  showList: {
                    'cover': '填充',
                    'contain': '留白',
                  },
                  key: 'fit', type: 'style', tag: 'radio'
                },
                a6: {
                  label: '文本样式', value: '400', sid: 'goods_weapp_s9',
                  showList: {
                    '400': '常规',
                    '600': '加粗',
                  },
                  key: 'font-weight', type: 'style', tag: 'radio'
                },
                a7: {
                  label: '文本对齐', value: 'left', sid: 'goods_weapp_s10',
                  showList: {
                    'left': '左对齐',
                    'center': '居中对齐'
                  },
                  key: 'text-align', type: 'style', tag: 'radio'
                },
                a8: {
                  label: '页面边距', value: 8, sid: 'goods_weapp_s11',
                  min: 0, max: 30,
                  key: 'padding', type: 'style', tag: 'el-slider'
                },
                a9: {
                  label: '商品间距', value: 8, sid: 'goods_weapp_s11',
                  min: 0, max: 30,
                  key: 'padding', type: 'style', tag: 'el-slider'
                },
                a10: {
                  label: '商品名称', value: '1', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsName', type: 'style', tag: 'radio'
                },
                a11: {
                  label: '商品描述', value: '2', sid: 'goods_weapp_s5',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsInfo', type: 'style', tag: 'radio'
                },
                a11label: {
                  label: '商品标签', value: '1', sid: 'goods_weapp_s5',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsInfo', type: 'style', tag: 'radio'
                },
                a11sp: {
                  label: '商品卖点', value: '1', sid: 'goods_weapp_s5',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsInfo', type: 'style', tag: 'radio'
                },
                a12: {
                  label: '商品价格', value: '1', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsPrice', type: 'style', tag: 'radio'
                },
                a13: {
                  label: '商品原价', value: '1', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsOldPrice', type: 'style', tag: 'radio'
                },
                a14: {
                  label: '商品销量', value: '1', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'goodsSaleNum', type: 'style', tag: 'radio',
                },
                a15: {
                  label: '购买按钮', value: '1', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'btnStyle', type: 'style', tag: 'select'
                },
                a16: {
                  label: '按钮样式', value: '1', sid: 'goods_weapp_s3',
                  showList: {
                    '1': '样式1',
                    '2': '样式2',
                    '3': '样式3',
                    '4': '样式4',
                    '5': '样式5',
                    '6': '样式6',
                    '7': '样式7',
                    '8': '样式8'
                  },
                  options: {
                    '1': '',
                    '2': '',
                    '3': '马上抢',
                    '4': '购买',
                    '5': '',
                    '6': '',
                    '7': '马上抢',
                    '8': '购买'
                  },
                  key: 'btnText', type: 'style', tag: 'button'
                },
                a17: {
                  label: '倒计时', value: '2', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'countdown', type: 'style', tag: 'radio'
                },
                a18: {
                  label: '进度条', value: '2', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'progress', type: 'style', tag: 'radio'
                },
                a19: {
                  label: '已售罄商品', value: '2', sid: 'goods_weapp_s12',
                  showList: {
                    '1': '隐藏',
                    '2': '不隐藏'
                  },
                  key: 'goodsTag', type: 'style', tag: 'radio'
                },
                // a20: { 
                //   label: '已团人数', value: '1', sid:'goods_weapp_s4',
                //   showList: {
                //     '1':'显示',
                //     '2':'不显示'
                //   },
                //   key: 'progress', type: 'style', tag: 'radio'
                // },
                a21: {
                  label: '显示分类', value: '2', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'progress', type: 'style', tag: 'radio'
                },
                a22: {
                  label: '显示更多', value: '2', sid: 'goods_weapp_s4',
                  showList: {
                    '1': '显示',
                    '2': '不显示'
                  },
                  key: 'progress', type: 'style', tag: 'radio'
                },
              },
              attrsort: [
                'a0', 'a1s', 'a1', 'a1t', 'a2', 'a2p', 'a21', 'a22', 'a3b', 'a3', 'a4', 'a5', 'a6', 'a7', 'a8', 'a9',
                'a10', 'a11', 'a11label', 'a11sp', 'a12', 'a13', 'a14', 'a15', 'a17',
              ]
            }
          )
        }
        that.$http.post("/renovationAssembly/update", _data).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "保存成功",
              showClose: true,
            });
            that.getAssemblyList()
          } else {
            that.$notify.info({
              title: "提示",
              message: response.data.message,
              showClose: true,
            });
          }
        }).catch(function (error) {
        })
      })
    },
    // 保存分类配置
    handleRenovationDetailSave(_boolean) {
      var that = this;
      this.$confirm("确定保存分类配置吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(confirm => {
        const _data = that.compList2.map((item, index) => {
          return {
            ...item,
            assemblyAttr: JSON.stringify(item.assemblyAttr),
            renovationCode: that.curDecorateClass.renovationCode,
            orderSq: index + 1,
            merchantCode: localStorage.getItem("merchantCode"),
            merchantName: localStorage.getItem("merchantName")
          }
        })
        that.$http.post("/renovationDetail/saveBatch", _data).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "保存成功",
              showClose: true,
            });
            that.getAssemblyList()
          } else {
            that.$notify.info({
              title: "提示",
              message: response.data.message,
              showClose: true,
            });
          }
        }).catch(function (error) {
        })
      })
    },
    handleRenovationDetailSaveAuto(_boolean) {
      var that = this;
      const _data = that.compList2.map((item, index) => {
        return {
          ...item,
          assemblyAttr: JSON.stringify(item.assemblyAttr),
          renovationCode: that.curDecorateClass.renovationCode,
          orderSq: index + 1,
          merchantCode: localStorage.getItem("merchantCode")
        }
      })
      that.$http.post("/renovationDetail/saveBatch", _data).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: "提示",
            message: "保存成功",
            showClose: true,
          });
          that.getAssemblyList()
        } else {
          that.$notify.info({
            title: "提示",
            message: response.data.message,
            showClose: true,
          });
        }
      }).catch(function (error) {
      })
    },

    // 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http.post("/seckillProduct/delete", { "id": id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getList();
          } else {
            that.$notify.info({
              title: "提示",
              message: response.data.message,
              showClose: true,
            });
          }

        });
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.decoration-page {
  box-sizing: border-box;
  padding: 16px 16px 16px 6px;
  width: 100%;
  height: 100%;
  background-color: #efefef;
}

.designer-cnt {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;

  .comp-group {
    width: 25%; //30%
    background-color: #fbfbfb;
    display: flex;

    .decorate-class {
      width: 140px;
      margin-right: 5px;
      height: 100%;
      background-color: #ffffff;
      flex-shrink: 0;

      .d-c-header {
        height: 50px;
        background-color: #f6f6f6;
        font-size: 16px;
        line-height: 24px;
        padding: 12px 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
      }

      .decorate-class-list {
        padding: 12px 16px;
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        color: #313131;
        border-bottom: 1px solid #f1f1f1;
      }

      .cur_dc {
        background-color: #fff1c3;
        // color: #fafafa;
      }
    }

    .comp-list {
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      width: 100%;
    }

    .comp-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: grab;
      width: 28%;
      margin: 10px calc(10% / 6);
      box-shadow: 0 0 9px 3px #fafafa;
    }
  }

  .display-body {
    // width: 28%;
    min-width: 375px;
    min-height: 723px;
    // height: calc(100% - 110px);
    height: 100%;
    position: relative;
    padding-bottom: 100px;
    box-sizing: border-box;
    overflow-y: auto;

    .cardDrag-container {
      width: 375px;
      // min-height: 723px;
      height: 100%;
      padding: 0 40px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 0;
      }

      .cardDrag-list-wrap {
        min-height: 723px;
        height: auto;
        background-color: #f8f8f8;
      }

      .comp-item {
        position: relative;
        overflow: visible;
        cursor: move;

        .comp_operate {
          position: absolute;
          top: 0;
          right: -40px;
          width: 38px;
          padding: 4px 0;
          text-align: center;
          background-color: #fff;
          box-sizing: border-box;
          font-size: 22px;
          color: #333;
        }

        .item_cnt {
          width: 100%;
          overflow: hidden;
        }

        .active_comp {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 9;
          border: 1px solid #155bd4;
        }
      }
    }

    .targetEl {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 80px);
      height: 90px;
      // margin-top: 20px;
      box-sizing: border-box;
      text-align: center;
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .attr-layer {
    width: 37%; //32%
    min-width: 480px;
    background-color: #fefefe;
    display: flex;

    .attr-page-manage {
      width: 150px;
      height: 100%;
      border: 1px solid #e1e1e1;

      .a-l-header {
        height: 50px;
        background-color: #f6f6f6;
        font-size: 16px;
        line-height: 24px;
        padding: 12px 16px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .attr-list {
        height: calc(100% - 50px);
        width: 100%;
        box-sizing: border-box;
        overflow-y: auto;

        .attr-list-item {
          padding: 12px 16px;
          cursor: pointer;

          .alii {
            font-size: 12px;
            color: #969799;
          }
        }
      }
    }

    .attr-detail {
      width: calc(100% - 150px);
      height: 100%;
      overflow: auto;

      .attr-item-box {
        padding: 6px 10px;
        margin-bottom: 10px;

        .attr-item-typedata {
          .attr-item-label {
            margin-bottom: 5px;
          }

          .attr-item-value {
            .temp-box {
              display: flex;
              flex-wrap: wrap;

              .temp-item {
                width: calc((100% - 40px)/4);
                height: 90px;
                margin: 0 5px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .temp-item-img {
                  width: 48px;
                  height: 48px;
                  margin-bottom: 8px;
                }

                .temp-item-name {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 20px;
                  text-align: center;
                  color: #333;
                }
              }

              .active_temp-item {
                .temp-item-name {
                  color: #155bd4;
                }
              }
            }

            .addImgList {
              width: 100%;
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;

              .img_info {
                color: #969799;
                font-weight: 400;
                margin-top: 8px;
                white-space: pre-wrap;
                font-size: 13px;
              }

              .imgList_box {
                // padding: 12px 0;
                width: 100%;
                box-sizing: border-box;

                .imgList-item {
                  border: 1px solid #e0e0e0;
                  margin: 12px 0;
                  padding: 4px;
                  box-sizing: border-box;
                  display: flex;

                  .ii-img-box {
                    width: 80px;
                    height: 100px;
                    position: relative;

                    .ii-img {
                      width: 100%;
                      height: 100%;
                    }

                    .ii-img-btn {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      width: 100%;
                      height: 20px;
                      background-color: rgba($color: #000000, $alpha: .5);
                      text-align: center;
                      font-size: 13px;
                      color: #ffffff;
                      cursor: pointer;
                    }
                  }

                  .ii-link-box {
                    width: calc(100% - 80px);
                    box-sizing: border-box;
                    height: 100px;
                    padding: 0 8px;

                    .ii-link-info {
                      font-weight: 400;
                      font-size: 14px;
                      line-height: 20px;
                      color: #999;
                    }

                    .ii-link {}
                  }
                }
              }

              .upload_btn {
                background: #efefef;
                border-radius: 2px;
                padding: 6px 10px 6px 14px;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                width: -webkit-fit-content;
                width: -moz-fit-content;
                width: fit-content;
                margin: 0 auto;
                color: #333;
                cursor: pointer;
              }
            }
          }
        }

        .attr-item-typestyle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;

          .attr-item-label {
            color: #969799;
            margin-right: 12px;
          }

          .attr-item-on {
            color: #333333;
            margin-right: 8px;
            font-size: 12px;
          }

          .attr-item-value {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }

      }
    }
  }
}

/deep/.el-collapse-item__content {
  padding-bottom: 0;
}

.left-drag-container div span {
  display: inline-block;
  width: 100% !important;
  height: calc(100vh - 180px) !important;
}

.cardDrag-list-wrap {
  display: inline-block;
  width: 100%;
  height: 100%;

  .comp-item {
    cursor: grab;
  }

  .active_comp {
    border: 1px solid #155bd4;
    // box-shadow: 0 0 5px #155bd4;
  }
}

/deep/.el-radio-button--small .el-radio-button__inner {
  padding: 4px 8px;
  height: 32px;
  min-width: 36px;
  line-height: 24px;
}

.assembly_img {
  width: 40px;
  height: 40px;
  overflow: hidden;
}
</style>
